<template>
  <div class="gs-publish-video">
    <!-- Publish video toggle -->
    <div v-if="isPublished || publishesLeft > 0" class="gs-switch-row">
      <span class="gs-switch-row__text">
        <span class="gs-switch-row__label">Published</span>
        <span class="gs-switch-row__help">{{ hint }}</span>
      </span>
      <gd-toggle :value="isPublished" @change="publishVideo" />
    </div>

    <div
      v-if="$store.getters.maxPublishVideos != -1"
      class="gs-publish-video__limit"
    >
      <span class="gs-publish-video__limit-icon"><i class="fa fa-info-circle"></i></span>
      <span>{{
        $t('frontend_groovevideo_links_cannot_publish', {
          maxPublish: publishesLeft > 0 ? publishesLeft : 0,
        })
      }}</span>
      <span class="gs-publish-video__upgrade" @click="$refs.upgradeModal.open() ">
        {{
          $t('frontend_groovevideo_videos_index_upgrade_to_pro_today')
        }}
      </span>
    </div>
    <upgrade-modal ref="upgradeModal" />
  </div>
</template>


<script>
import axios from 'axios';
import Notify from '@groovepages/gd-lib/notify';
import UpgradeModal from './upgradeModal';

export default {
  name: 'PublishVideo',
  mixins: [],
  props: {
    isPublished: {
      default: false,
    },
    publishesLeft: {
      default: 0,
    },
    videoId: {
      required: true,
    },
    // Sentence-case, not the "Publish Video" $t() key — this describes *why*
    // the toggle matters on a share/embed surface, not what the toggle is.
    hint: {
      type: String,
      default: 'Video must be published for these links to work.',
    },
  },
  components: {
    UpgradeModal
  },
  methods: {
    async publishVideo(value) {
      this.$emit('isLoading', true);

      const response = await axios.post(`videos/${this.videoId}/publish`, {
        is_published: value,
      });

      if (response.data.message === 'published_successfully') {
        this.$emit('updatePublishLimit', {
          isPublished: value,
          videoId: this.videoId,
        });

        if (value) {
          // Published
          Notify.success(
            this.$t('frontend_groovevideo_links_published_successfully')
          );
        } else {
          // Unpublished
          Notify.success(
            this.$t('frontend_groovevideo_links_unpublished_successfully')
          );
        }
      } else if (response.data.message === 'cannot_publish_video') {
        // Fail to publish
        Notify.fail(this.$t('frontend_groovevideo_links_publish_fail'));
      }

      this.$emit('isLoading', false);
    },
  },
};
</script>

<style scoped>
.gs-publish-video {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.gs-switch-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px;
  background: var(--gs-surface-subtle);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
}

.gs-switch-row__text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.gs-switch-row__label {
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.gs-switch-row__help {
  max-width: 56ch;
  color: var(--gs-muted-foreground);
  font-size: 13px;
  line-height: 1.5;
}

.gs-publish-video__limit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: var(--gs-muted-foreground);
  font-size: 13px;
}

.gs-publish-video__limit-icon {
  display: inline-flex;
}

.gs-publish-video__upgrade {
  color: var(--gs-primary);
  font-weight: 600;
  cursor: pointer;
}
</style>
